import { cn } from "@bentolabs/kit/utils";
import { cva, VariantProps } from "class-variance-authority";
import { Switch as RadixSwitch } from "radix-ui";

const variants = cva([], {
  variants: {
    color: {
      spearmint: [
        "data-[state=checked]:bg-spearmint/15 shadow-[0px_1px_1px_0px_#22ED4E1A_inset]",
      ],
      ultramarineBlue: [
        "data-[state=checked]:bg-ultramarine-blue/15 shadow-[0px_1px_1px_0px_#3B69FF29_inset]",
      ],
    },
  },
});

const thumbVariants = cva([], {
  variants: {
    color: {
      spearmint: ["data-[state=checked]:bg-spearmint"],
      ultramarineBlue: ["data-[state=checked]:bg-ultramarine-blue"],
    },
  },
});

type Props = VariantProps<typeof variants> & RadixSwitch.SwitchProps;

export const Switch = ({ color, className, ...props }: Props) => {
  return (
    <RadixSwitch.Root
      {...props}
      className={cn(
        "relative inline-flex h-8.5 w-14 shrink-0 cursor-pointer items-center rounded-xl p-1 outline-hidden transition-colors",
        "data-[state=unchecked]:bg-baltic-sea disabled:pointer-events-none",
        variants({ color }),
        className
      )}
    >
      <RadixSwitch.Thumb
        className={cn(
          "bg-nobel pointer-events-none inline-flex size-6 rounded-lg transition-transform",
          "data-[state=unchecked]:bg-nobel data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-0",
          thumbVariants({ color })
        )}
      />
    </RadixSwitch.Root>
  );
};
